import { Box } from "@mui/material";
import { CollectionType, QuestionType } from "app/types";
import React, { FC } from "react";
import DisplayQuestion from "./DisplayQuestion";

interface CardListQuestionsProps {
  questions: QuestionType[];
  collections:CollectionType[];
  translate: any;
}

const CardListQuestions: FC<CardListQuestionsProps> = ({
  questions,
  collections,
  translate,
}) => {
  return (
    <Box>
      {questions.length > 0 &&
        questions.map((question, index) => (
          <DisplayQuestion
            key={index}
            question={question}
            collections={collections}
            translate={translate}
          />
        ))}
    </Box>
  );
};

export default CardListQuestions;
